import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import Form from "react-bootstrap/Form";
import Collapse from "react-bootstrap/Collapse";
import {Button, Dropdown} from "react-bootstrap";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import DataRange from "components/datetime/DataRange";
import {MomentUtils} from "core/utils/MomentUtils";
import {AlertsKeysList} from "site-apps/alerts/AlertsTypesCharts";
import AuthContext from "context/AuthContext";
import {useContext} from "react";
import CustomTranslation from "core/customTranslation";

const translations = {
    es: {
        panel: "Municipios",
        routes_static: "Rutas estáticas",
    },
    en: {
        panel: "Municipalities",
        routes_static: "Static routes",
    },
};

const BoxFilter = ({filters, items, setItemsShown, buttonsTB, setButtonsTB, showFilter, filterByDate}) => {
    const {t: _Tt} = useTranslation("tables");
    const {t: _Tc} = useTranslation("choices");
    const {t: _TC} = CustomTranslation(translations);
    const {formatLocalDate, getDayRangeUTC, now} = MomentUtils();

    const defaultEndDate = now().toDate();
    const defaultStartDate = now().subtract(7, "days").toDate();

    const [dataRangeSelected, setDataRangeSelected] = useState(
        `${formatLocalDate(defaultStartDate, "DD/MM/YYYY")} - ${formatLocalDate(defaultEndDate, "DD/MM/YYYY")}`,
    );
    const {panel} = useContext(AuthContext);

    function onChangeSelect(e) {
        const {name, value} = e.target;
        let named = name.replace("filter-", "");
        if (value) {
            filters.chosen[named] = value;
        } else {
            delete filters.chosen[named];
        }
    }

    function clearFilters() {
        filters.chosen = {};

        const newDefaultEndDate = now().toDate();
        const newDefaultStartDate = now().subtract(7, "days").toDate();

        // ← usar formatLocalDate aquí también
        setDataRangeSelected(
            `${formatLocalDate(newDefaultStartDate, "DD/MM/YYYY")} - ${formatLocalDate(newDefaultEndDate, "DD/MM/YYYY")}`,
        );

        const range = getDayRangeUTC(newDefaultStartDate, newDefaultEndDate);
        filters.chosen.start_date = range.start;
        filters.chosen.end_date = range.end;
        delete filters.chosen.date;

        setItemsShown([...items.current.all]);
        items.current.showed = [...items.current.all];

        let buttons = {...buttonsTB};
        buttons.filter.applied = false;
        setButtonsTB(buttons);

        // Limpiar el select de estado/resolved
        const resolvedElement = document.getElementsByName("filter-resolved")[0];
        if (resolvedElement) {
            resolvedElement.value = "";
        }

        Object.keys(filters.list).forEach((key) => {
            const filterElement = document.getElementsByName("filter-" + key)[0];
            if (filterElement) {
                filterElement.value = "";
            }
        });
        applyFilters();
    }

    const clearDateRange = (e) => {
        const newDefaultEndDate = now().toDate();
        const newDefaultStartDate = now().subtract(7, "days").toDate();

        setDataRangeSelected(
            `${formatLocalDate(newDefaultStartDate, "DD/MM/YYYY")} - ${formatLocalDate(newDefaultEndDate, "DD/MM/YYYY")}`,
        );

        const range = getDayRangeUTC(newDefaultStartDate, newDefaultEndDate);
        filters.chosen.start_date = range.start;
        filters.chosen.end_date = range.end;
        delete filters.chosen.date;
    };

    function selectDataRange(startDate, endDate) {
        const range = getDayRangeUTC(startDate, endDate);

        // Usar localStart/localEnd para mostrar, que ya están anclados al día correcto
        setDataRangeSelected(
            `${formatLocalDate(range.localStart, "DD/MM/YYYY")} - ${formatLocalDate(range.localEnd, "DD/MM/YYYY")}`,
        );

        filters.chosen.start_date = range.start;
        filters.chosen.end_date = range.end;

        delete filters.chosen.date;
    }

    useEffect(() => {
        clearFilters();
    }, [items]);

    const applyFilters = () => {
        setItemsShown([...items.current.showed]);
        let buttons = {...buttonsTB};
        buttons.filter.applied = true;
        setButtonsTB(buttons);
        filters.filter();
    };

    return (
        <Collapse in={showFilter}>
            <div id="filter-collapse" className="pb-3">
                <div className="row">
                    <Button variant="link" type="button" onClick={clearFilters} style={{color: "black"}} className="col-1">
                        <FontAwesomeIcon icon="filter-circle-xmark" />
                    </Button>
                    <div className="col-2">
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            Estado
                        </label>
                        <Form.Select aria-label="Estados" name="filter-resolved" onChange={onChangeSelect}>
                            <option value="">Todas</option>
                            <option value="1">Resueltas</option>
                            <option value="0">Pendientes</option>
                        </Form.Select>
                    </div>
                    <div className="col-2">
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {_Tt("containers.type")}
                        </label>
                        <Form.Select aria-label="Default select example" name={"filter-type"} onChange={onChangeSelect}>
                            <option value="">Todos</option>
                            {AlertsKeysList.map((item, idx) => (
                                <option key={idx} value={item}>
                                    {_Tc("alerts_types." + item)}
                                </option>
                            ))}
                        </Form.Select>
                    </div>
                    {Object.keys(filters.list).map((key, idx) => (
                        <div className="col-2" key={idx}>
                            <label
                                style={{
                                    width: "100%",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                }}>
                                {_TC(key)}
                            </label>
                            <Form.Select aria-label="Default select example" name={"filter-" + key} onChange={onChangeSelect}>
                                <option value="">Todos</option>
                                {filters.list[key].map((item, id) => (
                                    <option
                                        key={id}
                                        value={Array.isArray(item) ? item[0] : item.id !== undefined ? item.id : item}>
                                        {Array.isArray(item) ? item[1] : item.name !== undefined ? item.name : item}
                                    </option>
                                ))}
                            </Form.Select>
                        </div>
                    ))}

                    {filterByDate ? (
                        <div className="col-2">
                            <label
                                style={{
                                    width: "100%",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                }}>
                                {_Tt("notifications.date_range")}
                            </label>
                            <ButtonGroup className="w-100">
                                <Dropdown className="w-100">
                                    <Dropdown.Toggle
                                        variant="Secondary"
                                        id="dropdown-basic"
                                        style={{
                                            border: "1px solid #ced4da",
                                            minWidth: "100%",
                                        }}
                                        className="custom-dropdown-toggle">
                                        <FontAwesomeIcon icon="fa-solid fa-calendar-day" />
                                        <label style={{width: "90%", textAlign: "center"}}> {dataRangeSelected}</label>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <DataRange rangeData={selectDataRange} maxSpan={30} maxDate={new Date()} />
                                    </Dropdown.Menu>
                                </Dropdown>
                                <Button
                                    type="button"
                                    variant="link"
                                    className="btn btn-sm mx-2 text-black"
                                    onClick={clearDateRange}
                                    title="Limpiar fechas">
                                    <FontAwesomeIcon icon="xmark" />
                                </Button>
                            </ButtonGroup>
                        </div>
                    ) : (
                        <></>
                    )}
                    <div className="col pt-3 mt-2 mx-3">
                        <Button variant="primary" onClick={applyFilters} title={_Tt("common.applyFilters")}>
                            <FontAwesomeIcon icon="magnifying-glass" />{" "}
                        </Button>
                    </div>
                </div>
            </div>
        </Collapse>
    );
};

export default BoxFilter;
